import { BaseModel } from './base';

export interface ProductCategory extends BaseModel {
  id: number;
  no: string;
  name: string;
  parent_id: number;
  icon: string;

  children: ProductCategory[];
}

export interface ProductAttrValue extends BaseModel {
  id: number;
  product_attr_id: number;
  name: string;
  image: string;
  price: number;
}

export interface ProductAttr extends BaseModel {
  id: number;
  product_id: number;
  name: string;
  priced: boolean;

  values: ProductAttrValue[];
}

export interface ProductSizeTable {
  titles: string[];
  values: string[][];
}

export interface Product extends BaseModel {
  id: number;
  name: string;
  no: string;
  category_id: number;
  status: string;
  descriptions: string[];
  url: string;
  images: string[];
  fabric: string;
  weight: number;

  attrs: ProductAttr[];
  priced_attr: ProductAttr;
  size_table: ProductSizeTable;

  collections?: string[];

  categories?: ProductCategory[];
}

export interface ProductCollection extends BaseModel {
  id: number;
  no: string;
  name: string;
  cover: string;
  description: string;
  product_count: number;
  products: Product[];
}

export enum ProductCollections {
  BestSellers = 'best-sellers',
  NewArrivals = 'new-arrivals',
  Sweaters = 'sweaters',
}
